module.exports = __webpack_public_path__ + "static/features-3-41da20e222135688af9493847fd77cc6.png";